// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LwZnG","right":"styles_right__4lN_o"};